import { render } from "./datatable.vue?vue&type=template&id=424a6012&scoped=true"
import script from "./datatable.vue?vue&type=script&lang=js"
export * from "./datatable.vue?vue&type=script&lang=js"

import "./datatable.vue?vue&type=style&index=0&id=424a6012&scoped=true&lang=css"
import "./datatable.vue?vue&type=style&index=1&id=424a6012&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424a6012"]])

export default __exports__